module.exports = __webpack_public_path__ + "img/kalendar.a0f4b51c.svg";